import { render, staticRenderFns } from "./PossibleRisksBlock.vue?vue&type=template&id=38966116&scoped=true"
import script from "./PossibleRisksBlock.vue?vue&type=script&lang=js"
export * from "./PossibleRisksBlock.vue?vue&type=script&lang=js"
import style0 from "./PossibleRisksBlock.vue?vue&type=style&index=0&id=38966116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38966116",
  null
  
)

export default component.exports